import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyCH_z1qYGG5kODqd6bL9iJ5WWoINTFhbR8",
  authDomain: "yavola-8ca8d.firebaseapp.com",
  projectId: "yavola-8ca8d",
  storageBucket: "yavola-8ca8d.appspot.com",
  messagingSenderId: "121000122763",
  appId: "1:121000122763:web:67db0a77ce6ef51493778e",
  measurementId: "G-7CRSLXLTQ0",
};

const app = initializeApp(firebaseConfig);
//Firestore
const db = getFirestore(app);
//Authentication
const auth = getAuth(app);

export { auth, db };
